module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-referral-f86c130b6fd137fcca45dda374dc3e5b.svg";